export default __webpack_public_path__ + "static/media/ar_2010_image.a2fe285d.jpg";